<div class="items-container">
  @if (optional) {
    <app-avatar-part
      [theme]="theme"
      [selected]="isPartSelected()"
      (click)="onPartCancel()"
    ></app-avatar-part>
  }
  @for (part of currentPartList; track part.id) {
    <app-avatar-part
      [theme]="theme"
      [avatarPart]="part"
      [selected]="isPartSelected(part)"
      (click)="onPartSelected(part)"
    ></app-avatar-part>
  }
</div>
